import Vue from 'vue'
import Promise from 'bluebird'

export const TaskConcurrency = {
  default: 0,
  restartable: 1,
  sharedReplay: 2
}

export class Task {
  constructor (task, concurrencyType) {
    if (concurrencyType != null && Object.values(TaskConcurrency).indexOf(concurrencyType) < 0) {
      concurrencyType = TaskConcurrency.default
      console.warn(
        `incorrect concurrencyType ${concurrencyType},
        should be one of ${Object.values(TaskConcurrency)}`
      )
    }
    if (task == null) { throw Error('task cannot be empty') }

    this._taskId = 0
    this._taskDict = {}
    this.task = task
    this.error = null
    this.concurrencyType = concurrencyType || TaskConcurrency.default
    this.state = {
      isRunning: false,
      isCanceld: false,
      isSuccessful: false
    }
  }

  /**
    The restartable modifier ensures that only one instance of
    a task is running by canceling any currently-running tasks
    and starting a new task instance immediately.
  */
  restartable () {
    this.concurrencyType = TaskConcurrency.sharedReplay
    return this
  }

  sharedReplay () {
    this.concurrencyType = TaskConcurrency.restartable
    return this
  }

  resetState () {
    Vue.set(this.state, 'isRunning', false)
    Vue.set(this.state, 'isCanceld', false)
    Vue.set(this.state, 'isSuccessful', false)
  }

  get isRestartable () {
    return this.concurrencyType === TaskConcurrency.restartable
  }

  get isSharedReplay () {
    return this.concurrencyType === TaskConcurrency.sharedReplay
  }

  get isIdle () {
    return !this.state.isRunning
  }

  get isRunning () {
    return this.state.isRunning
  }

  get isSuccessful () {
    return this.state.isSuccessful
  }

  get hasError () {
    return this.error != null
  }

  cancelAll () {
    this._cancelAll()
  }

  _addTask (taskId, task) {
    this._taskDict[taskId] = task
    return task
  }

  _removeTask (taskId) {
    if (this._taskDict[taskId]) {
      delete this._taskDict[taskId]
    }
  }

  _cancelAll () {
    Object.values(this._taskDict).forEach(task => {
      task.cancel()
    })
    this._taskDict = {}
  }

  async perform (...args) {
    if (this.isRestartable) {
      this._cancelAll()
    }
    const taskId = this.isSharedReplay
      ? Object.keys(this._taskDict)[0] || this._taskId++
      : this._taskId++

    this.error = null

    try {
      Vue.set(this.state, 'isRunning', true)
      Vue.set(this.state, 'isSuccessful', false)

      let task = this._taskDict[taskId]

      if (task == null) {
        const wrappedPromise = new Promise((resolve, reject, onCancel) => {
          if (onCancel) {
            args.push(onCancel)
          }
          return resolve(this.task(...args))
        })
        task = this._addTask(taskId, wrappedPromise)
      }

      const value = await task
      this._removeTask(taskId)

      Vue.set(this.state, 'isRunning', false)
      Vue.set(this.state, 'isSuccessful', true)
      return value
    } catch (e) {
      console.error(e)
      this.error = e
      this._removeTask(taskId)
      Vue.set(this.state, 'isRunning', false)
      Vue.set(this.state, 'isSuccessful', false)
    }
  }
}

export function task (...args) {
  return new Task(...args)
}



// WEBPACK FOOTER //
// ./src/services/task/task.js